export default __webpack_public_path__ + "static/media/restrospective-2.f95356cc.svg";